<template>
    <div>loanInfo 这个组件也很难配</div>
</template>

<script>
export default {
    name: 'loanInfo',

};
</script>


// WEBPACK FOOTER //
// src/staticComponents/loanInfo/loanInfo.vue